// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import MainLayout from "./layouts/MainLayout";
import PrivateRoute from "./components/PrivateRoute";
import { EquityAllHeatmap } from "./components/Equity_All_Heatmap";
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";
import ForgotPassword from "./pages/login/ForgotPassword";
import Cip from "./pages/cips/Cip";
import Summary from "./pages/summary/Summary";
import { SchoolEnrolledGrid } from "./components/SchoolEnrolledGrid";
import { Equity } from "./components/Equity_Gender";
import { LaborMarketInfo } from "./components/LaborMarketInfo";
import { PerformanceIndicators } from "./components/PerformanceIndicators";
import CipLayout from "./layouts/CipLayout";
import ChatHome from "./pages/ChatHome";
import RegionalOverview from "./pages/regional/RegionalOverview";
import AccountSettings from "./pages/account/AccountSettings";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        {/* ---------- PUBLIC ---------- */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* ---------- PRIVATE ---------- */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          {/* 👉 DEFAULT LANDING: Chat home */}
          <Route index element={<ChatHome />} />

          {/* CIP SECTION */}
          <Route path="cip" element={<CipLayout />}>
            <Route index element={<Cip />} />
          </Route>

          {/* Other dashboards */}
          <Route path="summary" element={<Summary />} />
          <Route path="enrollments" element={<SchoolEnrolledGrid />} />
          <Route path="equity" element={<Equity />} />
          <Route path="equityallheatmap" element={<EquityAllHeatmap />} />
          <Route path="lmi" element={<LaborMarketInfo />} />
          <Route path="performanceindicators" element={<PerformanceIndicators />} />
          <Route path="regional" element={<RegionalOverview />} />
          <Route path="account" element={<AccountSettings />} />
        </Route>

        {/* ---------- FALLBACK ---------- */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;